import NftMint from './NftMint';

export default NftMint;
